import React from "react";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import AvatarIcon from "../resources/AvatarIcon";
import { MiniLogo } from "../components/MiniLogo";
import { useTermsAndConditionsStyles } from "../themes/termsAndConditionsStyles";
import { withLocalize } from "react-localize-redux";

const BestWaterAppTermsAndConditionsPageGerman: React.FC = () => {
  const classes = useTermsAndConditionsStyles();
  const history = useHistory();
  const bwtLink = "https://www.bwt.com/";
  const cancellationFile =
    "https://www.bwt.com/de-at/-/media/bwt/at/documents/agb/wr-belehrung-formular.pdf";

  return (
    <div className={classes.pageContainer}>
      <div className={classes.topBar}>
        <Button
          classes={{ root: classes.buttonRoot }}
          onClick={() => {
            history.push("/");
          }}
        >
          <AvatarIcon color="var(--col-navy-500)" />
        </Button>
        <MiniLogo />
      </div>

      <div className={classes.titleContainer}>
        <div>Nutzungsbedingungen & Allgemeine Geschäftsbedingungen </div>
        <div>BWT BEST WATER APP</div>
        <div>BWT Holding GmbH</div>
      </div>

      <div className={classes.bodyContainer} style={{ gap: "12px" }}>
        <div className={classes.paragraph}>
          Die BWT Holding GmbH (im Folgenden "BWT" genannt) betreibt die BWT
          Best Water App. Nachfolgend finden Sie die Nutzungsbedingungen und die
          Allgemeinen Geschäftsbedingungen der BWT Best Water App, die für die
          Nutzung der Applikation gelten.
        </div>

        <div className={classes.paragraph}>
          Bitte lesen Sie die Bedingungen sorgfältig durch, da sie einen
          verbindlichen Vertrag zwischen Ihnen und BWT darstellen.
        </div>

        <div className={classes.subTitle}>
          <b>I. Nutzungsbedingungen BEST WATER APP</b>
        </div>

        <div className={classes.list}>
          <div>
            <b>1. Benutzerkonto:</b> Um die Dienste und Funktionen der BWT Best
            Water App nutzen zu können, muss ein Benutzerkonto eingerichtet
            werden. Dieses Benutzerkonto richtet sich an Verbraucher im Sinne
            von Punkt II.1 der nachfolgenden Allgemeinen Geschäftsbedingungen
            (im Folgenden "Benutzer" genannt). Wenn der Benutzer bereits ein BWT
            Best Water App-Konto hat, kann er sich mit diesem Konto anmelden.
          </div>

          <div>
            Ein Benutzerkonto ist personalisiert für einzelne namentlich
            registrierte Benutzer. In diesem Zusammenhang muss die Registrierung
            vor der Nutzung erfolgen. Der Benutzer muss die erforderlichen
            Pflichtfelder des Formulars wahrheitsgemäß ausfüllen. Es ist nicht
            gestattet, Namen oder Adressen anderer Personen oder ein Pseudonym
            einzugeben. Nach vollständiger Eingabe der Daten erhält der Benutzer
            eine E-Mail mit einem Aktivierungslink, der sieben (7) Tage ab dem
            Zeitpunkt des Versands der E-Mail gültig ist. Durch Bestätigung
            dieses Links wird das Online-Konto aktiviert. Falls das
            Benutzerkonto nicht bestätigt wird, wird das Benutzerkonto nach
            weiteren sieben (7) Tagen gelöscht. Der Benutzer wird per E-Mail
            über die Löschung informiert. In diesem Fall hat der Benutzer die
            Möglichkeit, sich erneut zu registrieren und die BWT Best Water App
            sowie das Benutzerkonto durch Eingabe der Zugangsdaten
            (E-Mail-Adresse und Passwort) zu nutzen.
          </div>

          <div>
            Der Benutzer ist für alle Aktivitäten verantwortlich, die über sein
            Benutzerkonto durchgeführt werden.
          </div>

          <div>
            Der Benutzer ist dafür verantwortlich, die Vertraulichkeit der
            Zugangsdaten zu seinem Benutzerkonto zu gewährleisten, unabhängig
            davon, von welchem Gerät aus er darauf zugreift, und er darf
            Informationen wie Benutzername und/oder Passwort nicht an andere
            Personen weitergeben. Der Benutzer muss daher alle empfohlenen
            Sicherheitsmaßnahmen einhalten, wie z. B. die Wahl eines sicheren
            Passworts und das Geheimhalten dieses Passworts unter allen
            Umständen. Hat der Benutzer berechtigte Gründe zur Annahme, dass die
            Zugangsdaten zu seinem Benutzerkonto unbefugt verwendet werden, muss
            das Passwort für das Benutzerkonto unverzüglich geändert werden.
          </div>

          <div>
            Der Benutzer ist dafür verantwortlich, dass alle persönlichen
            Angaben, Rechnungs- und Lieferadressen sowie Zahlungsmethoden stets
            auf dem neuesten Stand, korrekt und vollständig sind.
          </div>

          <div>
            Diese Daten können jederzeit über das Benutzerkonto aktualisiert
            werden. Jede Änderung der Daten im Benutzerkonto erfordert eine
            erneute Zustimmung zu den Allgemeinen Nutzungsbedingungen.
          </div>

          <div>
            Benutzer haben die Möglichkeit, ihr Benutzerkonto jederzeit zu
            löschen. BWT stellt den Benutzern der BWT Best Water App das
            Benutzerkonto kostenlos und auf unbestimmte Zeit zur Verfügung,
            behält sich jedoch das Recht vor, nach eigenem Ermessen Maßnahmen zu
            ergreifen, einschließlich des Ausschlusses eines Benutzers aus dem
            Programm, wenn der betreffende Benutzer gegen die
            Nutzungsbedingungen verstoßen oder das Programm in irgendeiner Weise
            missbraucht hat. Der Benutzer wird vor dem Ausschluss aus dem
            Programm informiert und hat die Möglichkeit, sich vor dem Ausschluss
            zu äußern.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>2. Geistige Eigentumsrechte:</b> Der gesamte Inhalt der BWT Best
            Water App, einschließlich Texte, Grafiken, Fotos, Bilder, bewegte
            Bilder, Sounds, Illustrationen und Software, ist Eigentum von BWT
            oder ihrer verbundenen Unternehmen, Lizenznehmer, Lizenzgeber
            und/oder Inhaltsanbieter. Dieser Inhalt ist durch Urheberrechte und
            andere Rechte geschützt. Die Nutzung ist nur mit ausdrücklicher
            schriftlicher Zustimmung des Eigentümers oder Lizenzgebers
            gestattet. Alle auf der App verwendeten Marken sind - sofern nicht
            anders angegeben - Marken des Anbieters und dürfen nicht ohne
            vorherige schriftliche Zustimmung des Anbieters verwendet werden.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>3. Inhalte:</b> BWT bemüht sich, die Informationen in der BWT
            Best Water App korrekt und aktuell zu halten. Die Haftung von BWT,
            ihren autorisierten Vertretern oder Beauftragten für Schäden im
            Zusammenhang mit jeglicher Nutzung der App sowie der Nichterfüllung
            einer Verpflichtung, die eine der Hauptleistungspflichten im Vertrag
            zwischen BWT und einem Kunden darstellt, ist auf Vorsatz und grobe
            Fahrlässigkeit beschränkt, soweit keine Personenschäden vorliegen.
            Die Haftung von BWT für finanzielle Verluste, die durch einfache
            Fahrlässigkeit verursacht werden, ist ausgeschlossen.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>4. Produktbeschreibung:</b> BWT ist nicht der Hersteller der
            Produkte und Dienstleistungen, die mit der BWT Best Water App
            verbunden sind, es sei denn, dies wird ausdrücklich angegeben.
            Darüber hinaus stellt BWT Links zu Seiten von verbundenen
            Unternehmen und bestimmten anderen Unternehmen, insbesondere den
            Herstellern der Produkte und Anbietern der Dienstleistungen, zur
            Verfügung. Dies dient als zusätzliche Information für den Benutzer.
            BWT ist nicht verantwortlich für diese Angebote oder Seiten.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>5. Nutzerdaten:</b> Die erhobenen Daten werden von BWT zur
            Erfüllung des Vertrags und im Zusammenhang mit der Nutzung der App
            erhoben und verarbeitet. Im Übrigen wird auf die
            Datenschutzrichtlinie von BWT Best Water App verwiesen.
          </div>
        </div>

        <div className={classes.list}>
          <div>
            <b>6. Elektronische Kommunikation:</b> BWT wird mit den Benutzern
            der BWT Best Water App auf verschiedene Weise elektronisch
            kommunizieren, z. B. per E-Mail, Textnachrichten oder
            Push-Nachrichten, Video- oder Telefonkonferenzen. Für vertragliche
            Zwecke stimmt der Benutzer zu, dass dieses Dokument und alle
            Zustimmungen, Benachrichtigungen, Veröffentlichungen und andere
            Mitteilungen sowie Rechnungen elektronisch von BWT übermittelt
            werden, sofern diese nicht der Schriftform bedürfen, es sei denn,
            zwingende gesetzliche Vorschriften oder vertragliche Vereinbarungen
            erfordern eine andere Form der Kommunikation.
          </div>
        </div>

        <div className={classes.subTitle}>
          <b>II. Allgemeine Geschäftsbedingungen</b>
        </div>

        <div className={classes.list}>
          <b>1. Anwendungsbereich</b>

          <div>
            1.1. Diese Allgemeinen Geschäftsbedingungen (im Folgenden "AGB"
            genannt) gelten für die Nutzung der BWT Best Water App.
          </div>

          <div>
            1.2. Die BWT Best Water App kann kostenlos auf ein mobiles Gerät im
            Apple AppStore sowie im Google PlayStore heruntergeladen werden. Für
            die Nutzung des BWT Online-Shops gelten zusätzliche
            Nutzungsbedingungen, die&nbsp;
            <a href={bwtLink} target="_blank" rel="noreferrer">
              hier
            </a>
            &nbsp;abrufbar sind.
          </div>

          <b>2. Beschreibung der App </b>

          <div>
            2.1. Die mobile App ermöglicht es dem Benutzer, bestimmte von BWT
            bereitgestellte Dienste entweder lokal oder durch Verbindung mit den
            BWT-Cloud-Diensten zu nutzen.
          </div>

          <div>
            2.2. Die BWT Best Water App bietet den Benutzern Einblicke in ihre
            verschiedenen BWT-Produkte, einschließlich: Steuerung von Produkten
            (z. B. Wasserfilter, Enthärter, Wasserspender, Poolroboter), falls
            zutreffend. Überwachung des Produktzustands, Bestellung von
            Verbrauchsmaterialien (einschließlich Salz, Filter usw.), falls
            zutreffend. Fernsteuerung des Produkts, falls zutreffend. Teilen des
            Produkts mit Ihrer Familie oder einem Techniker.
          </div>

          <div>
            2.3. Benutzer können auch Benachrichtigungen über ihre registrierten
            Produkte erhalten, wie z. B. Wasserfilter, Kalkschutzsysteme,
            Wasserspender, Pooltester-Kits und Tischwasserfilter.
          </div>

          <b>3. Kosten </b>

          <div>
            3.1. Die Registrierung sowie die Nutzung der App, einschließlich
            ihrer Inhalte und Dienstleistungen, sind kostenlos. BWT behält sich
            das Recht vor, in Zukunft Premium-Funktionen einzuführen, die als
            In-App-Kauf aktiviert werden können.
          </div>

          <b>4. Laufzeit </b>

          <div>
            4.1. Diese Vereinbarung tritt mit der Annahme der Allgemeinen
            Geschäftsbedingungen der App in Kraft und endet mit der
            Deinstallation der App durch den Benutzer.
          </div>

          <b>5. Änderungen der AGB und neueste Version </b>

          <div>
            5.1. BWT behält sich das Recht vor, die AGB von Zeit zu Zeit zu
            überprüfen und zu überarbeiten, insbesondere um den Anforderungen
            von Anbietern von Plattformen für den Vertrieb von Anwendungen
            gerecht zu werden und Änderungen in Recht oder bewährter Praxis
            widerzuspiegeln oder zusätzliche von uns eingeführte Funktionen zu
            berücksichtigen. Wir werden den Nutzer über solche Änderungen
            informieren, indem wir die aktualisierte Version der AGB („Neue
            AGB“) an die vom Nutzer bei der Registrierung angegebene
            E-Mail-Adresse senden. Wenn der Nutzer die App nicht innerhalb eines
            Monats nach Erhalt der neuen AGB von seinem Gerät(en) deinstalliert
            und somit diesen Vertrag kündigt, gelten die Neuen AGB für die
            Nutzung der App.
          </div>

          <b>6. Kontakt </b>

          <div>
            6.1. Bei Fragen, Beschwerden oder Anmerkungen zur App, den Diensten
            oder den Inhalten kann sich der Nutzer unter app@bwt-group.com oder
            telefonisch unter +43 6232 50110 an BWT wenden.
          </div>

          <b>7. Lizenzgewährung </b>

          <div>
            7.1. BWT gewährt dem Nutzer das nicht ausschließliche, nicht
            übertragbare Recht, zeitlich begrenzt auf die Dauer der Nutzung der
            App durch den Nutzer, die Software für eigene Zwecke zu nutzen,
            seine Daten im Rahmen der Software zu speichern und zu verarbeiten,
            die Benutzeroberfläche der Software gemäß der Vereinbarung zur
            Anzeige auf dem Bildschirm in den hierfür verwendeten Endgeräten in
            den Hauptspeicher zu laden und die daraus resultierenden
            Reproduktionen der Benutzeroberfläche anzufertigen.
          </div>

          <div>
            7.2. Diese Lizenzgewährung gilt entsprechend für alle
            Aktualisierungen und/oder Upgrades der App, der Inhalte und Dienste
            von BWT.
          </div>

          <b>8. Pflichten und Rechte des Nutzers </b>

          <div>8.1. Der Nutzer darf: </div>

          <div>
            - die App oder einen Dienst nicht rechtswidrig, für einen
            rechtswidrigen Zweck oder in einer Weise nutzen, die diesen
            Bedingungen widerspricht, oder betrügerisch oder böswillig handeln,
            beispielsweise durch Hacking oder Einschleusen von bösartigem Code
            wie Viren oder schädlichen Daten in die App, einen Dienst oder ein
            Betriebssystem;
          </div>

          <div>
            - unsere geistigen Eigentumsrechte oder die geistigen
            Eigentumsrechte Dritter im Zusammenhang mit der Nutzung der App oder
            eines Dienstes durch den Nutzer nicht verletzen, einschließlich
            durch die Übermittlung von Material (soweit eine solche Nutzung
            nicht durch diese Bedingungen lizenziert ist);
          </div>

          <div>
            - keine diffamierenden, beleidigenden oder anderweitig anstößigen
            Inhalte im Zusammenhang mit der Nutzung der App oder eines Dienstes
            durch den Nutzer übermitteln;
          </div>

          <div>
            - die App oder einen Dienst nicht in einer Weise nutzen, die unsere
            Systeme oder Sicherheit beschädigen, deaktivieren, überlasten,
            beeinträchtigen oder gefährden oder andere Nutzer stören könnte; und
          </div>

          <div>
            - keine Informationen oder Daten von einem Dienst oder unseren
            Systemen sammeln oder ernten oder versuchen, Übertragungen zu oder
            von den Servern, auf denen ein Dienst ausgeführt wird, zu
            entschlüsseln.
          </div>

          <div>
            8.2. Der Nutzer ist verpflichtet, das bei der Registrierung gewählte
            Passwort sowie die anderen Zugangsdaten geheim zu halten und
            sicherzustellen, dass von ihm autorisierte Personen, denen
            Zugangsdaten zugänglich gemacht werden, dies ebenfalls tun. BWT wird
            den Nutzer zu keinem Zeitpunkt außerhalb der Software nach seinem
            Passwort fragen.
          </div>

          <b>9. Vertragsverletzungen und Kündigung </b>

          <div>
            9.1. Der Nutzer hat das Recht, dieses Agreement jederzeit ohne
            Angabe von Gründen durch Deinstallation der App von seinem Gerät(en)
            zu kündigen.
          </div>

          <div>
            9.2. BWT kann nach eigenem Ermessen ohne vorherige Ankündigung
            dieses Agreement und damit auch das Nutzerkonto sowie den Zugang des
            Nutzers zu dieser App einschließlich der darin enthaltenen Inhalte
            oder Dienste kündigen, wenn (i) der Nutzer gegen Klausel 8.1 dieser
            AGB verstößt oder (ii) wenn BWT den Nutzer auf einen Verstoß gegen
            eine andere Bestimmung dieser AGB hingewiesen hat, dem Nutzer
            mindestens 14 Tage Zeit zur Abhilfe eingeräumt hat und der Nutzer
            den Verstoß innerhalb dieser Frist nicht abgestellt hat.
          </div>

          <b>10. Verbraucherwiderruf </b>

          <div>
            10.1. Wenn der Kunde Verbraucher ist, hat er das Recht, den Vertrag
            innerhalb von vierzehn Tagen ohne Angabe von Gründen zu widerrufen.
            Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem der
            Kunde oder ein vom Kunden benannter Dritter, der nicht als
            Frachtführer tätig ist, die Waren in Besitz genommen hat. Um das
            Widerrufsrecht auszuüben, muss der Kunde BWT mittels einer
            eindeutigen Erklärung (z.B. ein per Post versandter Brief oder eine
            E-Mail) über die Entscheidung, diesen Vertrag zu widerrufen,
            informieren. Der Kunde kann dafür das&nbsp;
            <a href={cancellationFile} target="_blank" rel="noreferrer">
              beigefügte Muster-Widerrufsformular
            </a>
            &nbsp;verwenden, dies ist jedoch nicht vorgeschrieben.
          </div>

          <div>
            10.2. Kein Widerrufsrecht besteht oder ein bestehendes
            Widerrufsrecht erlischt bei:
          </div>

          <div>
            - Waren, die versiegelt geliefert werden und aus Gründen des
            Gesundheitsschutzes oder der Hygiene nicht zur Rückgabe geeignet
            sind, sofern ihre Versiegelung nach der Lieferung entfernt wurde.
            Dies gilt insbesondere für Wasserfilterkartuschen, die mit einer
            Hygienekappe gesichert sind. Das Widerrufsrecht erlischt vorzeitig,
            wenn die Hygienekappe entfernt wird.
          </div>

          <div>
            - Waren, die nach der Lieferung aufgrund ihrer Beschaffenheit
            untrennbar mit anderen Gütern vermischt wurden.
          </div>

          <div>
            - Waren, die nach Kundenspezifikationen angefertigt werden oder
            eindeutig auf persönliche Bedürfnisse zugeschnitten sind.
          </div>

          <div>
            Um die Widerrufsfrist einzuhalten, reicht es aus, dass der Kunde die
            Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der
            Widerrufsfrist absendet.
          </div>

          <div>10.3. Die Widerrufserklärung ist zu richten an:</div>
          <div>BWT Sports & Digital Services GmbH</div>
          <div>Walter-Simmer-Str. 4</div>
          <div>5310 Mondsee</div>
          <div>Österreich</div>
          <div>E-mail: shop@bwt.com</div>
          <div>T für Österreich: 0800 800 555</div>
          <div>T für Deutschland: 0800 112 22 23</div>

          <div>10.4. Folgen des Widerrufs:</div>
          <div>
            enn der Kunde diesen Vertrag widerruft, hat BWT alle Zahlungen, die
            BWT vom Kunden erhalten hat, einschließlich der Lieferkosten (mit
            Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass der
            Kunde eine andere Art der Lieferung, als die von BWT angebotene
            günstigste Standardlieferung gewählt hat), unverzüglich und
            spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem
            die Mitteilung über den Widerruf dieses Vertrags bei BWT eingegangen
            ist. Für diese Rückzahlung verwendet BWT dasselbe Zahlungsmittel,
            das der Kunde bei der ursprünglichen Transaktion eingesetzt hat, es
            sei denn, mit dem Kunden wurde ausdrücklich etwas anderes
            vereinbart; in keinem Fall werden dem Kunden wegen dieser
            Rückzahlung Entgelte berechnet. Der Verkäufer kann die Rückzahlung
            verweigern, bis er die Waren zurückerhalten hat oder bis der Kunde
            den Nachweis erbracht hat, dass er die Waren zurückgesandt hat, je
            nachdem, welches der frühere Zeitpunkt ist.
          </div>

          <div>
            Der Kunde hat die Waren unverzüglich und in jedem Fall spätestens
            binnen vierzehn Tagen ab dem Tag, an dem er BWT über den Widerruf
            dieses Vertrags unterrichtet hat, an BWT zurückzusenden oder zu
            übergeben. Die Frist ist gewahrt, wenn der Kunde die Waren vor
            Ablauf der Frist von vierzehn Tagen absendet.
          </div>

          <div>Der Verkäufer trägt die Kosten der Rücksendung der Waren.</div>

          <div>
            Der Kunde muss für einen etwaigen Wertverlust der Waren nur
            aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der
            Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht
            notwendigen Umgang mit ihnen zurückzuführen ist.
          </div>

          <b>11. Gewährleistung und Entschädigung</b>

          <div>
            11.1. Es gelten die gesetzlichen Gewährleistungsvorschriften.
          </div>

          <div>
            11.2. Die Haftung von BWT im Falle von Vorsatz, grober
            Fahrlässigkeit, Verletzung von Leben, Körper oder Gesundheit und bei
            Ansprüchen nach dem Produkthaftungsgesetz richtet sich nach den
            gesetzlichen Bestimmungen. Darüber hinaus ist die Haftung für
            leichte Fahrlässigkeit ausgeschlossen - außer im Falle der
            Verletzung von Leben, Körper oder Gesundheit.
          </div>

          <div>
            11.3. Wenn dem Nutzer durch den Verlust von Daten Schäden entstehen,
            haftet BWT nicht dafür, soweit die Schäden durch eine regelmäßige
            und vollständige Sicherung aller relevanten Daten durch den Nutzer
            hätten vermieden werden können. Der Nutzer ist dafür verantwortlich,
            eine regelmäßige und vollständige Datensicherung selbst oder durch
            Dritte durchzuführen.
          </div>

          <div>11.4. Verfügbarkeit </div>

          <div>
            BWT stellt dem Nutzer die Software in der aktuellen Version zur
            Nutzung am Routerausgang des Rechenzentrums, in dem sich der Server
            mit der Software befindet (“Übergabepunkt”), zur Verfügung. Die
            Software, die für den Betrieb der Software im Rechenzentrum
            erforderliche Rechenleistung sowie der dafür erforderliche Speicher-
            und Datenverarbeitungsplatz werden von BWT bereitgestellt. BWT
            schuldet jedoch nicht die Herstellung und Aufrechterhaltung der
            Datenverbindung zwischen den IT-Systemen des Nutzers und dem
            beschriebenen Übergabepunkt. BWT gewährleistet nicht die ständige
            Verfügbarkeit der App, der Inhalte und Dienste. Ausfallzeiten
            aufgrund von Wartung, Software-Updates und aufgrund von Umständen
            (wie technischen Problemen Dritter, höherer Gewalt), die nicht im
            Einflussbereich von BWT liegen und für die BWT daher nicht
            verantwortlich ist und die über die von BWT angebotenen Dienste
            nicht zugänglich sind, können nicht vollständig vermieden werden.
            Der Nutzer erklärt, keine Schadensersatz- und/oder
            Gewährleistungsansprüche wegen Ausfällen geltend zu machen. BWT
            behält sich das Recht vor, die App, Inhalte oder Dienste (oder Teile
            davon) aus beliebigen Gründen zu entfernen oder den Betrieb der App,
            Inhalte oder Dienste (oder Teile davon) zu unterbrechen, soweit dies
            zur Durchführung routinemäßiger oder außerplanmäßiger
            Wartungsarbeiten, Fehlerbehebungen oder anderer Änderungen
            erforderlich ist.
          </div>

          <div>11.5. Updates </div>

          <div>
            BWT ist berechtigt, die Software weiterzuentwickeln und zu ändern,
            sofern diese Weiterentwicklung oder Änderung (i) zur Einhaltung
            zwingender gesetzlicher Anforderungen durch BWT erforderlich ist,
            (ii) nur eine Anpassung an den jeweiligen bewährten oder aktuellen
            Stand der Technik bedeutet oder (iii) nicht über das hinausgeht, was
            bei vergleichbarer Software branchenüblich und für den Nutzer
            zumutbar ist, d.h. die berechtigte Erwartung des Nutzers,
            wesentliche Funktionen der verfügbaren Software weiterhin nutzen zu
            können, nicht enttäuscht. BWT stellt Support- und Wartungsdienste
            für die Software gemäß dem geltenden Verbraucherschutzrecht zur
            Verfügung. BWT hält die Software auf dem neuesten Stand, um dem
            Nutzer alle neuen Updates und Sicherheitspatches kostenlos zur
            Verfügung zu stellen. BWT wird den Nutzer über die Verfügbarkeit
            neuer Updates und Sicherheitspatches über die bei der Registrierung
            angegebene E-Mail-Adresse informieren. Der Nutzer ist verpflichtet,
            die Updates und Sicherheitspatches sofort nach deren Verfügbarkeit
            zu installieren. Wenn der Nutzer ein Update oder einen
            Sicherheitspatch nicht installiert, kann die ordnungsgemäße Funktion
            der Software nicht gewährleistet werden und BWT haftet nicht für
            diesen Mangel. “Update” bedeutet Updates der Software für
            Reparaturen, Verbesserungen oder neue Funktionen, die von BWT auf
            den Geräten der Nutzer angewendet werden, einschließlich Updates der
            Dokumentation infolge solcher Updates.
          </div>

          <b>12. Datenschutz </b>

          <div>
            Die erhobenen Daten werden von BWT zur Vertragserfüllung und im
            Zusammenhang mit der Auftragsabwicklung verarbeitet. Im Übrigen wird
            auf die Datenschutzerklärung der BWT App verwiesen.
          </div>

          <b>13. Änderung der Anschrift </b>

          <div>
            Der Kunde verpflichtet sich, BWT jede Änderung seiner Wohnadresse
            und E-Mail-Adresse mitzuteilen, solange das vertragsgegenständliche
            Rechtsgeschäft nicht beiderseitig vollständig erfüllt ist. Wird die
            Mitteilung unterlassen, so gelten Erklärungen auch dann als
            zugegangen, wenn sie an die zuletzt bekannt gegebene Adresse
            gesendet werden.
          </div>

          <b>14. Vertragssprache </b>

          <div>
            Die dem Kunden zur Verfügung stehenden Sprachen für den
            Vertragsschluss sind Deutsch und Englisch. Der Kunde kann die
            gewünschte Sprache der App durch Auswahl der jeweiligen Sprache in
            den Benutzerkontoeinstellungen des BWT-Onlineshops festlegen.
          </div>

          <b>15. Impressum/Betreiber der App</b>

          <div>Betreiber der BWT Best Water App </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gridTemplateRows: "repeat(6, 1fr)",
              gridAutoFlow: "column",
              columnGap: "8px",
            }}
          >
            <div>
              <b>BWT Holding GmbH</b>
            </div>
            <div>Walter-Simmer-Str. 4</div>
            <div>5310 Mondsee</div>
            <div>Österreich</div>
            <div>E-Mail: app@bwt.com </div>
            <div>T.: +43 6232 50110</div>
            <div style={{ gridRow: "2" }}>Firmenbuchnummer: FN 96162 s</div>
            <div>Firmenbuchgericht: Landesgericht Wels</div>
            <div>UID Nr.: ATU23473603</div>
            <div>Aufsichtsbehörde: BH Vöcklabruck</div>
            <div>Mitglied der österreichischen Wirtschaftskammer</div>
          </div>

          <b>16. Anwendbares Recht, Gerichtsstand und Streitbeilegung </b>

          <div>
            16.1. Es gilt österreichisches Recht unter Ausschluss der nationalen
            Kollisionsnormen und unter Ausschluss des
            UN-Kaufrechtsübereinkommens. Diese Rechtswahl gilt nur insoweit, als
            dem Kunden als Verbraucher nicht der gewährte Schutz durch zwingende
            Bestimmungen des Rechts des Staates, in dem er seinen gewöhnlichen
            Aufenthalt hat, entzogen wird.
          </div>

          <div>
            16.2. Eine Klage des Kunden gegen BWT kann entweder vor den
            Gerichten des Mitgliedstaates, in dessen Hoheitsgebiet BWT ihren
            Sitz hat, oder vor dem Gericht des Ortes, an dem der Kunde seinen
            Wohnsitz hat, erhoben werden. Eine Klage von BWT gegen den Kunden
            kann nur vor den Gerichten des Mitgliedstaates erhoben werden, in
            dessen Hoheitsgebiet der Kunde seinen Wohnsitz hat.
          </div>

          <div>
            16.3. Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) zur Verfügung, die unter folgendem Link
            abrufbar ist: https://ec.europa.eu/consumers/odr/. Eine
            Verpflichtung zur Teilnahme an einem Streitbeilegungsverfahren vor
            einer Verbraucherschlichtungsstelle besteht nicht. Die BWT ist auch
            nicht bereit, an einem solchen Streitbeilegungsverfahren
            teilzunehmen.
          </div>
        </div>
      </div>
    </div>
  );
};

export default withLocalize(BestWaterAppTermsAndConditionsPageGerman);
